import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData } from './Model'
import { fetchHTML, fetchPDF } from '@/common/fetch'

export interface SimpleMachineGroup {
  id: string
  name: string
}

export const ErrorCodesWizardStep1 = () => {
  const { translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()
  const [error, setError] = React.useState<string | null>(null)

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  const validateAndNext = () => {
    const code = (wizardData as any).errorcode?.trim?.() ?? ''
    if (!code) {
      setError('Errorcode is required')
      return
    }
    setError(null)
    nextStep()
  }

  return (
    <>
      <div>
        <h3>{translates.for("wizards.aimachine.errorcode.title")}</h3>

        <form
          className="main-form"
          onSubmit={(e) => {
            e.preventDefault()
            validateAndNext()
          }}
        >
          <div className="form-field">
            <label htmlFor="errorcode">{translates.for("wizards.aimachine.errorcode.code")}:</label>
            <input
              id="errorcode"
              name="errorcode"
              type="text"
              required
              value={(wizardData as any).errorcode ?? ''}
              onChange={(e) => {
                const value = e.target.value
                if (error && value.trim()) setError(null)

                updateWizardData({
                  ...wizardData,
                  errorcode: value,
                } as any)
              }}
              placeholder=""
            />

            {error && <div className="text-red-600 mt-1">{error}</div>}
          </div>

          <div className='right-btns'>
            <button className='btn btn-next' type="submit">
              {translates.for("wizards.aimachine.errorcode.next")}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}